/**
 * homepage-chart
 *
 * @author    Alexis Vedia <alexis.vedia@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

import "babel-polyfill";
import coreFactory from "./common/core";
import sandboxFactory from "./common/sandbox";

// Modules
import viewing from "./homepage-chart/viewing";

const core = coreFactory(window.jQuery, sandboxFactory);

core.createModule("viewing-homepage-chart", viewing);

core.startAll();

// Homepage Carousel
jQuery(".carousel-indicators li:first, .carousel-inner .item:first").addClass("active");
